module.exports = __webpack_public_path__ + "static/media/descargar.7bee68bb.svg";